import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* global gisApi */

/*
  This component need a script that currently is injected by tealium. After load will call onGisApiReady function
 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMedia } from '@sainsburys-tech/boltui-hooks';
import { isEmpty } from '@sainsburys-tech/boltui-utils';
import { Modal, ModalHeader, ModalContent, Image } from '@sainsburys-tech/bolt';
import enabledStyledBrands from './enabledStyledBrands.json';
import * as Styled from './GoInStoreWidget.styles';
export var getEnabledStyledBrand = function getEnabledStyledBrand() {
  var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // @Note: Brands for which we allow restyling the widget
  return Array.isArray(enabledStyledBrands) && enabledStyledBrands.length > 0 ? enabledStyledBrands.find(function (enabledBrand) {
    var _enabledBrand$name;

    return (enabledBrand === null || enabledBrand === void 0 ? void 0 : (_enabledBrand$name = enabledBrand.name) === null || _enabledBrand$name === void 0 ? void 0 : _enabledBrand$name.toLowerCase()) === brand.toLowerCase();
  }) || null : null;
};

var generateGISClerkUnavailableModal = function generateGISClerkUnavailableModal(_ref) {
  var modalTitle = _ref.modalTitle,
      modalContent = _ref.modalContent,
      modalState = _ref.modalState,
      closeModal = _ref.closeModal;
  return /*#__PURE__*/React.createElement(Modal, {
    id: "clerk-unavailable-modal",
    show: modalState,
    onClose: closeModal,
    height: "auto",
    padding: true,
    "data-test": "clerk-unavailable-modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, modalTitle), /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement(Styled.Content, null, modalContent), /*#__PURE__*/React.createElement(Styled.ContentLink, {
    href: "https://www.argos.co.uk/features/video-call-a-brand-expert",
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": "Our brand expert service"
  }, "Find out more about our brand expert service")));
};

var GoInStoreWidget = function GoInStoreWidget(_ref2) {
  var showMobileBadge = _ref2.showMobileBadge,
      dataTest = _ref2['data-test'],
      hideMobile = _ref2.hideMobile,
      brand = _ref2.brand;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isGoInStoreApiReady = _useState2[0],
      setIsGoInStoreApiReady = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isClerkAvailable = _useState4[0],
      setIsClerkAvailable = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      modalState = _useState6[0],
      setModalState = _useState6[1];

  var isMobile = useMedia([false, true], false, ["(min-width: 768px)", "(max-width: 768px)"]);
  var isMobileBadge = isMobile && showMobileBadge && !hideMobile;
  var token = brand.toLowerCase() !== 'lg' ? '04720998-c695-47e8-8bc7-4765d3412e5b' // default
  : '352cee05-e457-44bc-8d4c-9156b679002f'; // LG

  var clerkImage = "url(\"//gis.goinstore.com/gis/images/img/cta-logo.png?locale=en_GB&retailerToken=".concat(token, "\")");
  useEffect(function () {
    window.onGisApiReady = function () {
      setIsGoInStoreApiReady(true);
      gisApi.enableStandardJourney();
      gisApi.checkClerkAvailability(function () {
        return setIsClerkAvailable(true);
      }, function () {
        return setIsClerkAvailable(false);
      });

      if (document.querySelector('#gis-cta')) {
        clerkImage = document.querySelector('#gis-cta').style['background-image'];
      }
    };
  }, []);
  useEffect(function () {
    window.widgetClick = function () {
      if (isClerkAvailable) {
        gisApi.startCall();
      } else {
        setModalState(true);
      }
    };

    if (!isClerkAvailable) {
      var existCondition = setInterval(function () {
        if (document.getElementById('gis-cta')) {
          clearInterval(existCondition);
          document.getElementById('gis-cta').setAttribute('onclick', 'window.widgetClick()');
        }
      }, 500);
    }
  }, [isClerkAvailable]);

  var handleClick = function handleClick() {
    if (isClerkAvailable === false) {
      setModalState(true);
    } else {
      /**
       * Nap-1663 - Empty function triggers Post Call Summary
       */
      gisApi.startCall(function () {});
    }
  };

  var closeModal = function closeModal() {
    return setModalState(false);
  };

  if (!isGoInStoreApiReady) return null; // Checking and retrieving the brand to restyle if existing

  var brandToStyle = getEnabledStyledBrand(brand); // Generating the branded Modal for clerk unavailability

  var brandRelatedClerkUnavailableModal = brandToStyle && brandToStyle.id === 'lg' ? generateGISClerkUnavailableModal({
    modalTitle: 'Sorry, the LG expert is currently unavailable or in a call',
    modalContent: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", null, "Please try again when the light is green"), /*#__PURE__*/React.createElement("p", null, "We\u2019re available Wednesday to Sunday 10am \u2013 6pm")),
    modalState: modalState,
    closeModal: closeModal
  }) : generateGISClerkUnavailableModal({
    modalTitle: 'Sorry, the Habitat expert is currently unavailable or in a call',
    modalContent: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", null, "Please try again when the light is green"), /*#__PURE__*/React.createElement("p", null, "We\u2019re available Monday to Sunday 10am \u2013 6pm")),
    modalState: modalState,
    closeModal: closeModal
  }); // @NOTE: For the rebranding text, for LG having 'an' before it works fine but not for samsung, where it needs an 'a' only

  return /*#__PURE__*/React.createElement(React.Fragment, null, isMobileBadge && /*#__PURE__*/React.createElement(Styled.Widget, {
    onClick: handleClick,
    onKeyPress: handleClick,
    tabIndex: 0,
    role: "button",
    "aria-pressed": "false",
    dataTest: dataTest
  }, /*#__PURE__*/React.createElement(Styled.Circle, {
    clerkImage: clerkImage,
    brand: brandToStyle ? brandToStyle.id : ''
  }, /*#__PURE__*/React.createElement(Styled.AvailabilityCircle, {
    active: isClerkAvailable
  }), isClerkAvailable && /*#__PURE__*/React.createElement(Styled.IconAvailable, {
    width: 16,
    height: 16
  }), !isClerkAvailable && /*#__PURE__*/React.createElement(Styled.IconNotAvailable, {
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement(Styled.Box, {
    brand: brandToStyle ? brandToStyle.id : ''
  }, /*#__PURE__*/React.createElement("p", null, "Video call", ' ', brandToStyle ? /*#__PURE__*/React.createElement(React.Fragment, null, "a ", /*#__PURE__*/React.createElement("strong", null, brandToStyle.name)) : 'an in-store', ' ', "expert about this product.", ' ', /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("u", null, "Call an expert"))), /*#__PURE__*/React.createElement("div", null, brandToStyle && !isEmpty(brandToStyle.logo) ? /*#__PURE__*/React.createElement(Image, {
    height: brandToStyle.logo.height || 0,
    width: brandToStyle.logo.width || 0,
    src: brandToStyle.logo.src || '',
    alt: brandToStyle.logo.alt || ''
  }) : null))), isClerkAvailable === false && brandRelatedClerkUnavailableModal);
};

GoInStoreWidget.displayName = 'GoInStoreWidget';
GoInStoreWidget.defaultProps = {
  showMobileBadge: true,
  'data-test': 'component-go-in-store-widget',
  hideMobile: false,
  brand: ''
};
GoInStoreWidget.propTypes = {
  /**
   * Prop for show the custom mobile badge
   */
  showMobileBadge: PropTypes.bool,

  /**
   * Prop for setting data-test attribute for testing
   */
  'data-test': PropTypes.string,

  /**
   * Prop for hiding on mobile
   */
  hideMobile: PropTypes.bool,

  /**
   * Prop for brand
   */
  brand: PropTypes.string
};
export default GoInStoreWidget;